import React, { useState, useEffect } from "react";
import { StreamChat } from "stream-chat";
import {
  Chat,
  Channel,
  ChannelHeader,
  MessageList,
  MessageInput,
  Window,
} from "stream-chat-react";
import { MessageSquare } from "lucide-react"; // Add an icon library for the toggle button
import "stream-chat-react/dist/css/v2/index.css";

import { getChatToken } from "../services/chatservice"; // Ensure the path is correct
import "./chat.css"; // Add custom styles for the popup

export default function ChatComponent() {
  const [client, setClient] = useState(null);
  const [channel, setChannel] = useState(null);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust breakpoint as needed
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Check on initial render

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const initializeChat = async () => {
      const chatClient = StreamChat.getInstance("zupc2mt5h627"); // Replace with your API key

      try {
        const userId = `guest-${Math.random().toString(36).substring(2, 10)}`;
        const { token } = await getChatToken(userId, true);

        await chatClient.connectUser(
          {
            id: userId,
            name: `Guest-${userId}`,
            image: "https://getstream.io/random_svg/?name=Guest",
          },
          token
        );

        const liveChannel = chatClient.channel("livestream", "betting-live", {
          name: "Betting Live Chat",
        });

        await liveChannel.watch();

        setClient(chatClient);
        setChannel(liveChannel);
      } catch (error) {
        console.error("Error initializing chat:", error);
      }

      return () => {
        if (chatClient) {
          chatClient.disconnectUser();
        }
      };
    };

    initializeChat();
  }, []);

  return (
    <>
      <button
        className="chat-toggle"
        onClick={() => setIsChatOpen(!isChatOpen)}
      >
        {isMobile ? (
          <MessageSquare size={20} /> // Show chat icon for mobile users
        ) : isChatOpen ? (
          "Close Chat"
        ) : (
          "Open Chat"
        )}
      </button>

      {isChatOpen && client && channel && (
        <div className="chat-popup">
          <Chat client={client} theme="str-chat__theme-light">
            <Channel channel={channel}>
              <Window>
                <ChannelHeader />
                <MessageList />
                <MessageInput />
              </Window>
            </Channel>
          </Chat>
        </div>
      )}
    </>
  );
}
